import { Outlet } from "react-router-dom";


const Review = () => {
  return (<Outlet />)
}
export default Review;
